import * as React from 'react'
import { cn } from '../../lib/utils'

/**
 * shadcn/ui Input.
 *
 * ⚠️ font-size 는 16px 아래로 내리지 말 것 — iOS Safari/WebView 가 포커스 시
 *    화면을 확대해 버린다. 수기 시트의 date/time 입력에서 특히 문제가 된다.
 */
const Input = React.forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>(
  ({ className, type, ...props }, ref) => (
    <input
      ref={ref}
      type={type}
      className={cn(
        'flex h-12 w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-base',
        'placeholder:text-slate-400',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40 focus-visible:border-primary',
        'disabled:cursor-not-allowed disabled:bg-slate-50 disabled:opacity-60',
        className,
      )}
      {...props}
    />
  ),
)
Input.displayName = 'Input'

export { Input }
